<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick } from "vue";

import SelectZeitraum from "@/components/common/SelectZeitraum.vue";
import { getSiteData } from "@/NavigationHelper";
import { Globals } from "@/Globals";
import { showPDF } from "@/PdfHelper";
import { formatDate } from "@/editor/CalenderHelper";
import { DialogParameter, showSnackbar, showDialog } from "@/UIHelper";
import { globalsBezeichnung, globalsKennung, globalsLayout } from "@/local";
import { mountedBase, BaseSetup } from "@/DataLoaderStatic";
const emit = defineEmits(["back"]);
let printItem!: ALLDruck;
let pickerMulti: string[] = [new Date().toISOString().substr(0, 7)];
let picker = <string>new Date().toISOString().substr(0, 7);
let startVal = ref<Date>(AUApi.Current.zeitbereich.von);
let endVal = ref<Date>(AUApi.Current.zeitbereich.bis);
let landscape = ref<boolean>(true);
let multiple = ref<boolean>(false);
let multipleSelect = ref<boolean>(false);
let type = ref<string>("months");
let printZeitbereich = ref<APIZeitbereich>(AUApi.Current.zeitbereich);
let farbe = ref<boolean>(false);
let umbruch = ref<boolean>(false);
let nurSumme = ref<boolean>(false);
let keineSumme = ref<boolean>(false);
let gruppiert: boolean = false;
let periodisch = ref<boolean>(false);
let eMail = ref<boolean>(false);
let pdfSave: boolean = false;
let gruppiertDisabled: boolean = false;
let localeZeit: string = AUApi.Current.user.locale;
let maxDate = ref<string>("");
let printLayout: any[] = [];
let selectedLayout: string = "";
let zeitFormat = ref<boolean>(false);
let vectorPlanung = ref<PlanungItems[] | null>(null);
let ausPlanung = ref<boolean>(false);
let ausPlanungVG = ref<boolean>(false);

let loading: boolean = false;
let persDruck = ref<boolean>(false);
let showSchicht = ref<boolean>(false);
let noSelect = ref<boolean>(false); // auswahl monate soll ausgeschaltet werden können
let showNurSumme = ref<boolean>(false);
let showkeineSumme = ref<boolean>(false);
let showButton = ref<boolean>(false);
let selectAll = ref<boolean>(false);
let keinZR = ref<boolean>(false);
let tab = ref<number>(0);

let pause = ref<boolean>(false);
let az = ref<boolean>(false); // geplante Arbeitszeit (Schicht)
let ist = ref<boolean>(false); // Ist Zeit (Schicht)
let soll = ref<boolean>(false); // Soll Arbeitszeit (Schicht)
let diff = ref<boolean>(false); // Differenz Zeit (Schicht)
let vonbis = ref<boolean>(false);
let memo = ref<boolean>(false);
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  emitBack: () => emit("back"),
};
declare interface PlanungItems {
  aic?: number;
  select?: boolean;
  GroupID?: number;
  id?: number;
  Text?: string;
  tagesAnzeige?: string;
}
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  pageParams.vecStamm = [];
  vectorPlanung.value = [];
  await mountedBase(uiData, pageParams);
  const siteData = getSiteData();
  if (siteData?.printItem) {
    printItem = siteData.printItem;
    farbe.value = printItem.farbe ?? false;
    gruppiertDisabled = printItem.keineGruppierung ?? false;
    umbruch.value = printItem.seitenUmbruch ?? false;
    const checkType = printItem.periode;
    showSchicht.value = printItem.schicht ?? false;
    showNurSumme.value = printItem.nurSumme ?? false;
    showkeineSumme.value = printItem.keineSumme ?? false;
    periodisch.value = printItem.abschnittPeriode ?? false;
    keinZR.value = printItem.keinZR ?? false;
    if (showSchicht.value) {
      farbe.value = true;
      pause.value = true; // soll immer vorinitialisert werden
    }
    addLayout();
    if (checkType === "offen") {
      if (siteData && siteData.zeitbereich && siteData.zeitbereich.bereich) {
        if (siteData.zeitbereich.bereich === "Monat") {
          type.value = "months";
        }
      }
      if (siteData && siteData.zeitbereich && siteData.zeitbereich.bereich === "Woche") {
        type.value = "week";
      } else if (siteData && siteData.zeitbereich && siteData.zeitbereich.bereich === "Tag") {
        type.value = "day";
      } else {
        type.value = "months";
      }
    } else if (checkType === "Jahr") {
      type.value = "year";
    } else if (checkType === "Monat") {
      type.value = "month";
    } else if (checkType === "Woche") {
      type.value = "week";
    }
  }
  if (siteData && siteData.aic) {
    pageParams.queryAIC = siteData.aic;
  }
  if (siteData?.vecStamm) {
    pageParams.vecStamm = siteData.vecStamm;
  }
  if (siteData?.vectorPlanung) {
    pageParams.vecStamm = [];
    vectorPlanung.value = siteData.vectorPlanung;
    ausPlanung = siteData.ausPlanung;
    if (vectorPlanung.value) {
      for (let i = 0; i < vectorPlanung.value.length; i++) {
        vectorPlanung.value[i].select = false;
      }
    }
    ausPlanungVG = siteData.ausPlanungVG;
  }
  if (siteData?.pers) {
    persDruck.value = true;

    // es soll immer möglich sein..
    // multipleSelect.value = false;
  }
  if (siteData?.zeitbereich) {
    const pickDate = siteData.zeitbereich.von;
    pickerMulti = [new Date(pickDate).toISOStringWithTZ().substr(0, 7)];
    picker = new Date(pickDate).toISOStringWithTZ().substr(0, 7);
  }
  if (siteData?.noSelect) {
    noSelect.value = siteData.noSelect;
    let bisDate = undefined;
    const vonDate = new Date(siteData.zeitbereich.von);
    if (siteData?.zeitbereich) {
      bisDate = new Date(siteData.zeitbereich.bis);
    } else {
      bisDate = new Date(new Date(vonDate).lastInMonth());
    }
    let bereich = "Tag";
    if (siteData?.zeitbereich?.bereich) {
      bereich = siteData.zeitbereich.bereich;
    }
    if (type.value === "months") {
      bereich = "Monat";
    } else if (type.value === "year") {
      bereich = "Jahr";
    } else if (type.value === "week") {
      bereich = "Woche";
    }
    printZeitbereich.value = {
      bereich,
      von: vonDate,
      bis: bisDate,
    };
  }
  const lastDay = new Date(new Date().getFullYear(), 11, 31);
  const stringDate = formatDate(lastDay, "yyyy-MM-dd");
  if (stringDate) {
    maxDate.value = stringDate;
  }
  if (AUApi.Current.user.zeitFormat === "min") {
    zeitFormat.value = true;
  }
});
function selectChange(val: PlanungItems, value: boolean | null) {
  if (value != null) {
    val.select = value;
    showButton.value = false;
    let id = 0;
    if (!pageParams.vecStamm) {
      pageParams.vecStamm = [];
    }
    if (ausPlanung) {
      id = val.id ?? 0;

      if (value) {
        pageParams.vecStamm.push(id);
      } else {
        pageParams.vecStamm = pageParams.vecStamm.filter(
          (c: number) => c !== id
        );
      }
    } else {
      id = val.GroupID ?? 0;
      if (value) {
        pageParams.vecStamm.push(id);
      } else {
        pageParams.vecStamm = pageParams.vecStamm.filter(
          (c: number) => c !== id
        );
      }
    }
    if (pageParams.vecStamm && pageParams.vecStamm.length > 0) {
      showButton.value = true;
    }
  }
}
function onPrintItemClick(
  fromDialog: boolean = false,
  tabUbergabe: number[] = []
) {
  loading = true;
  const zeitraum: any[] = [];
  let currentPrintzeitbereich = printZeitbereich.value;
  if (multipleSelect.value === true && periodisch.value) {
    if (pickerMulti?.length > 0) {
      for (let i = 0; i < pickerMulti.length; i++) {
        const month = pickerMulti[i];
        const von = new Date(month).toISOStringWithTZGMT();
        const bis = new Date(von).lastInMonth().toISOStringWithTZGMT();
        zeitraum.push({ von, bis });
      }
    }
  } else if (multipleSelect.value === true && !periodisch.value) {
    if (pickerMulti?.length > 0) {
      // es soll der erste und der letzte Monat als Zeitbereich gesetzt werden
      // warum bleibt month leer??

      const vals = pickerMulti.map((d) => new Date(d).valueOf());

      const von = new Date(Math.min(...vals));
      const bis = new Date(Math.max(...vals)).lastInMonth();
      let bereich = "Tag";
      if (type.value === "months") {
        bereich = "Monat";
      } else if (type.value === "year") {
        bereich = "Jahr";
      }
      currentPrintzeitbereich = {
        bereich,
        von,
        bis,
      };
    }
  }
  if (!currentPrintzeitbereich) {
    const zeitbereichVon = AUApi.Current.zeitbereich.von;
    const zeitbereichBis = AUApi.Current.zeitbereich.bis;
    let bereich = "Tag";
    if (type.value === "months") {
      bereich = "Monat";
    } else if (type.value === "year") {
      bereich = "Jahr";
    }
    const vonDate = new Date(zeitbereichVon);
    const bisDate = new Date(new Date(zeitbereichBis).lastInMonth());
    currentPrintzeitbereich = {
      bereich,
      von: vonDate,
      bis: bisDate,
    };
  }
  let begriff: any;
  if (printItem) {
    begriff = globalsKennung(Globals.Begriff, printItem.kennung);
  }
  if (!pageParams.queryAIC) {
    pageParams.queryAIC = AUApi.Current.user.aic;
  }
  const jokerStt = [];
  jokerStt.push({
    aic: 0, // aic Stammtyp
    sync: pageParams.queryAIC, // aic Stammsatz
  });
  if (begriff?.abfrage && fromDialog !== true) {
    showDialog({
      title: globalsBezeichnung(
        Globals.Begriff,
        "Web_Bitte_waehlen",
        "Bitte wählen"
      ),
      width: 250,
      site: "ModellDialog",
      data: {
        zeitbereich: pageParams.zeitbereich,
        query: begriff.abfrage,
        aic: pageParams.queryAIC,
      },
      okButton: true,
      onClose: (x: DialogParameter) => {
        if (x?.returnedData?.length > 0) {
          tabUbergabe = x.returnedData;
        }
        if (x?.dialogResult === true) {
          onPrintItemClick(true, tabUbergabe);
        } else {
          loading = false;
        }
        return true;
      },
    });
    return; // nicht weitermachen nur dialog aufmachen}
  }
  AUApi.Current.print(
    pageParams.queryAIC ?? AUApi.Current.user.aic,
    printItem.aic,
    currentPrintzeitbereich,
    farbe.value,
    umbruch.value,
    selectedLayout,
    nurSumme.value,
    keineSumme.value,
    gruppiert,
    zeitFormat.value,
    pageParams.vecStamm,
    tabUbergabe,
    zeitraum,
    eMail.value,
    pdfSave,
    jokerStt,
    pause.value,
    az.value,
    ist.value,
    soll.value,
    diff.value,
    vonbis.value,
    memo.value,
    periodisch.value
  ).then((res: any) => {
    const resp = res.data.file;
    const info = res.data.error;
    const infoMail = res.data?.EMail;
    let mailError;
    if (infoMail) {
      mailError = res.data?.EMail[0]?.error;
    }
    // const mailError = res.data?.EMail[0]?.error;
    const infoPdf = res.data?.indDB;
    // const pdfError = res.data?.TabFehler;
    // const infoTable = [];
    // for (let i = 0; i < pdfError.length; i++) {
    //   const row = pdfError[i];
    //   infoTable.push(row);
    // }
    // const textTable = infoTable.join("<br>");
    // if (info) {
    //   showSnackbar({
    //     text: info,
    //     color: "error",
    //   });
    // } else
    if (infoMail) {
      if (mailError) {
        showSnackbar({
          text: mailError,
          color: "error",
        });
      } else {
        const text =
          "Email wurde versendet an: " +
          infoMail[0].adresse +
          " " +
          infoMail[0].name;
        showSnackbar({
          text,
          color: "error",
        });
      }
    } else if (infoPdf) {
      showSnackbar({
        text: infoPdf,
        color: "info",
      });
    } else if (info) {
      showSnackbar({
        text: info,
        color: "error",
      });
    } else {
      onShowPdf(resp);
    }
    loading = false;
  });
}
function onShowPdf(pdfFile: any) {
  // const url = $api.fullUrl("pdf3/" + pdfFile, "", true);
  showPDF(pdfFile);
  // const res = window.open(url);
}
function selectedValueChanged(args: any) {
  selectedLayout = args;
}
function valueChanged(args: any) {
  if (!args) {
    return;
  }
  let bereich = "Tag";
  if (type.value === "months") {
    bereich = "Monat";
  } else if (type.value === "year") {
    bereich = "Jahr";
  }
  const vonDate = new Date(args);
  const bisDate = new Date(new Date(vonDate).lastInMonth());

  printZeitbereich.value = {
    bereich,
    von: vonDate,
    bis: bisDate,
  };
}
function addLayout() {
  printLayout = globalsLayout(Globals.Begriff);
}
function selectChangeAll(data: any) {
  if (data) {
    if (vectorPlanung.value) {
      pageParams.vecStamm = [];
      for (let i = 0; i < vectorPlanung.value.length; i++) {
        const row = vectorPlanung.value[i];
        pageParams.vecStamm.push(row.aic ?? row.id ?? row.GroupID ?? 0);
        vectorPlanung.value[i].select = true;
      }
    }
  } else {
    pageParams.vecStamm = [];
    if (vectorPlanung.value) {
      for (let i = 0; i < vectorPlanung.value.length; i++) {
        const row = vectorPlanung.value[i];
        vectorPlanung.value[i].select = false;
      }
    }
  }
  if (pageParams.vecStamm && pageParams.vecStamm.length > 0) {
    showButton.value = true;
  } else {
    showButton.value = false;
  }
}
</script>
<template>
  <v-card :loading="uiData.showLoading" v-if="uiData.initialized" class="pa-0">
    <v-card-title
      v-if="!noSelect && !keinZR"
      align="left"
      class="bg-grey-lighten-3 text-white pa-2 mb-5 border rounded-sm"
    >
      <SelectZeitraum
        min-width="500px"
        v-model="printZeitbereich"
        :range="true"
        @change="valueChanged"
        :color="'grey-darken-3'"
      />
    </v-card-title>
    <v-card
      variant="outlined"
      class="pb-5 mb-5"
      v-if="vectorPlanung && vectorPlanung.length > 0"
    >
      <v-toolbar color="teal" dark>
        <v-toolbar-title> Auswahl </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-checkbox
          class="pr-5"
          @update:modelValue="selectChangeAll"
          :label="globalsBezeichnung(Globals.Begriff, 'alle', 'alle')"
          v-model="selectAll"
          density="compact"
          :hide-details="true"
        ></v-checkbox>
      </v-toolbar>
      <v-list densitity="compact" class="baselistItems">
        <v-list-item
          ref="liste"
          v-for="(planItem, ux) in vectorPlanung"
          :key="'ui' + ux"
        >
          <v-list-item-title v-if="!ausPlanung">{{
            planItem.Text
          }}</v-list-item-title>
          <v-list-item-title v-if="ausPlanungVG || ausPlanung">{{
            planItem.tagesAnzeige
          }}</v-list-item-title>
          <template v-slot:prepend>
            <v-checkbox
              @update:modelValue="(val) => selectChange(planItem, val)"
              v-model="planItem.select"
              hide-details
            ></v-checkbox>
          </template>
        </v-list-item>
      </v-list>
    </v-card>
    <v-tabs v-model="tab">
      <v-tab value="one">allgemein</v-tab>

      <v-tab v-if="showSchicht" value="two">Schicht - Definitionen</v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="one" bg-color="success">
        <v-card align="center" min-width="100%">
          <v-card-text class="pa-0 mb-0">
            <v-row class="pa-0">
              <v-col cols="4" class="py-0">
                <v-checkbox
                  v-model="farbe"
                  color="black"
                  :label="
                    globalsBezeichnung(Globals.Begriff, 'Web_Farbe', 'Farbe')
                  "
                  hide-details
                >
                </v-checkbox>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-checkbox
                  v-model="umbruch"
                  color="black"
                  :label="
                    globalsBezeichnung(
                      Globals.Begriff,
                      'Web_Seitenumbruch',
                      'Seitenumbruch'
                    )
                  "
                  hide-details
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row class="pa-0 mt-0">
              <v-col cols="6" class="py-0">
                <v-checkbox
                  v-model="zeitFormat"
                  color="black"
                  :label="
                    globalsBezeichnung(
                      Globals.Begriff,
                      'DruckFormat',
                      'Format in hh:mm'
                    )
                  "
                  hide-details
                >
                </v-checkbox>
              </v-col>
              <v-col cols="6" class="pa-0" v-if="!noSelect">
                <v-checkbox
                  v-model="periodisch"
                  color="black"
                  :label="
                    globalsBezeichnung(
                      Globals.Begriff,
                      'Periode',
                      'Abschnitt/Periode'
                    )
                  "
                  hide-details
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <!-- <v-row class="pa-0 mt-0" v-if="persDruck">
              <v-col cols="12" class="py-0">
                <v-checkbox
                  v-model="zeitFormat"
                  color="black"
                  :label="
                    globalsBezeichnung(
                      Globals.Begriff,
                      'DruckFormat',
                      'Format in hh:mm'
                    )
                  "
                  hide-details
                >
                </v-checkbox>
              </v-col>
            </v-row> -->
            <v-row v-if="!persDruck" class="pa-0 mt-0">
              <v-col cols="4" class="py-0">
                <v-checkbox
                  v-if="showNurSumme"
                  v-model="nurSumme"
                  color="black"
                  :label="
                    globalsBezeichnung(Globals.Begriff, 'NurSumme', 'nur Summe')
                  "
                  hide-details
                >
                </v-checkbox>
              </v-col>
              <v-col cols="4" class="pa-0">
                <v-checkbox
                  v-if="showkeineSumme"
                  v-model="keineSumme"
                  color="black"
                  :label="
                    globalsBezeichnung(
                      Globals.Begriff,
                      'keine_Summe',
                      'keine Summe'
                    )
                  "
                  hide-details
                >
                </v-checkbox>
              </v-col>
              <!-- <v-col cols="4" class="pa-0">
            <v-checkbox
              v-model="gruppiert"
              :disabled="gruppiertDisabled"
              color="black"
              :label="
                globalsBezeichnung(Globals.Begriff, 'Gruppiert', 'gruppiert')
              "
            >
            </v-checkbox>
          </v-col> -->
            </v-row>
            <v-row v-if="!persDruck" class="pa-0 mt-0">
              <v-col cols="6" class="py-0">
                <v-checkbox
                  v-if="eMail"
                  v-model="eMail"
                  color="black"
                  :label="
                    globalsBezeichnung(
                      Globals.Begriff,
                      'E-Mail2',
                      'e-Mail erstellen'
                    )
                  "
                  hide-details
                >
                </v-checkbox>
              </v-col>
              <!-- <v-col cols="4" class="py-0">
            <v-checkbox
              v-if="printItem.pdfSave"
              v-model="pdfSave"
              color="black"
              :label="
                globalsBezeichnung(Globals.Begriff, 'PDF', 'PDF erstellen')
              "
            >
            </v-checkbox>
          </v-col> -->
            </v-row>

            <v-row class="pa-2">
              <v-col cols="12">
                <v-select
                  variant="outlined"
                  density="compact"
                  color="error"
                  clearable
                  solo
                  v-if="printLayout.length > 0"
                  :items="printLayout"
                  :label="
                    globalsBezeichnung(
                      Globals.Begriff,
                      'Seitenlayout',
                      'Seitenlayout'
                    )
                  "
                  :placeholder="
                    globalsBezeichnung(
                      Globals.Begriff,
                      'Seitenlayout',
                      'Seitenlayout'
                    )
                  "
                  item-title="bezeichnung"
                  item-value="aicLayout"
                  @change="selectedValueChanged"
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tabs-window-item>
      <v-tabs-window-item value="two" bg-color="success">
        <v-row>
          <v-col cols="6" class="py-0">
            <v-checkbox
              v-model="az"
              color="black"
              :label="
                globalsBezeichnung(Globals.Begriff, 'AZ', 'gepl. Arbeitszeit')
              "
              hide-details
            >
            </v-checkbox>
          </v-col>
          <v-col cols="4" class="pa-0">
            <v-checkbox
              v-model="ist"
              color="black"
              :label="globalsBezeichnung(Globals.Begriff, 'ist', 'Ist')"
              hide-details
            >
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-0">
            <v-checkbox
              v-model="soll"
              color="black"
              :label="globalsBezeichnung(Globals.Begriff, 'soll', 'Soll')"
              hide-details
            >
            </v-checkbox>
          </v-col>
          <v-col cols="4" class="pa-0">
            <v-checkbox
              v-model="diff"
              color="black"
              :label="globalsBezeichnung(Globals.Begriff, 'Diff', 'Differenz')"
              hide-details
            >
            </v-checkbox>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="6" class="py-0">
            <v-checkbox
              v-model="vonbis"
              color="black"
              :label="
                globalsBezeichnung(
                  Globals.Begriff,
                  'von_bis_Text',
                  'Von - Bis Text'
                )
              "
              hide-details
            >
            </v-checkbox>
          </v-col>
          <v-col cols="6" class="pa-0">
            <v-checkbox
              v-model="memo"
              color="black"
              :label="
                globalsBezeichnung(Globals.Begriff, 'memo2', 'Umbruch vor Memo')
              "
              hide-details
            >
            </v-checkbox>
          </v-col>
        </v-row> -->
      </v-tabs-window-item>
    </v-tabs-window>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-if="
          ((ausPlanung || ausPlanungVG) && showButton) ||
          (!ausPlanung && !ausPlanungVG)
        "
        variant="text"
        :loading="loading"
        color="green"
        @click="onPrintItemClick()"
        icon="mdi-printer"
      >
        <template v-slot:loader>
          <span class="custom-loader">
            <v-icon color="red" light>mdi-cached</v-icon>
          </span>
        </template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.baselistItems {
  overflow-y: scroll;
  max-height: 300px;
  padding: 0 0 0 0;
}
</style>
